import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import Select from "react-select";
import "./index.scss";
import { useState } from "react";

const CustomSelect = ({
  name,
  control,
  options = [],
  rules,
  disabled = false,
  className = "",
  label = "",
  placeholder = "Select",
  errors = {},
  defaultValue = null,
  onChange,
  usePortal = false,
  ...props
}) => {
  const [menuPortalTarget, setMenuPortalTarget] = useState(null);

  useEffect(() => {
    if (usePortal) {
      setMenuPortalTarget(document.body);
    }
  }, [usePortal]);

  return (
    <div className={`select-group ${className}`}>
      {label && <label>{label}</label>}
      <div className="select-field">
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          rules={rules}
          render={({ field: { onChange: fieldOnChange, value } }) => {
            const selectedOption =
              options.find((option) => option.value === value) || null;

            return (
              <Select
                isDisabled={disabled}
                options={options}
                placeholder={placeholder}
                value={selectedOption}
                onChange={(selectedOption) => {
                  fieldOnChange(selectedOption?.value || null);
                  if (onChange) onChange(selectedOption);
                }}
                classNamePrefix={`react-select ${
                  errors[name] ? "select__invalid" : ""
                }`}
                {...props}
                // menuPortalTarget={document.body}
                // menuPortalTarget={usePortal ? menuPortalTarget : undefined}
                menuPortalTarget={usePortal ? menuPortalTarget : undefined}
                menuPosition="fixed"
                isClearable
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  dropdownIndicator: (base, state) =>
                    state.isDisabled ? { ...base, display: "none" } : base,
                  indicatorSeparator: (base, state) =>
                    state.isDisabled ? { ...base, display: "none" } : base,
                }}
              />
            );
          }}
        />
      </div>
      {errors[name] && (
        <div className="select--helper__invalid">{errors[name]?.message}</div>
      )}
    </div>
  );
};

export default CustomSelect;
